// extracted by mini-css-extract-plugin
module.exports = {"Backdrop":"Backdrop_Backdrop__1kpZo","BackdropSpinner":"Backdrop_BackdropSpinner__3-jlP"};